import { useState } from "react";
import { Box, Card, CardContent, Tab, Tabs, Typography } from "@mui/material";
import FinanceStatementCreate from "./finance-statement-create";
import Header from "../header";
import BalanceSheet from "../balance-sheet";
import IncomeStatement from "../balance-sheet/income-statement";
import ProfitAndLossStatement from "../balance-sheet/profit-loss-statement";

const FinanceTabs = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [rowId, setRowId] =useState(null)

    const handleTabChange = (_, newValue) => {
        setActiveTab(newValue);
    };

    const handleSaveSuccess = () => {
        setActiveTab(1);
    };

    const handleSave = () => {
        setActiveTab(2);
    };

    const handleSaveIncrement = () => {
        setActiveTab(3);
    };

    return (
        <Card sx={{ height: '100%', marginTop: "10px", overflow: "hidden" }}>
            <CardContent>
                <Header name="FINANCE STATEMENT" />

                {/* Tab Navigation */}
                <Tabs value={activeTab} onChange={handleTabChange}>
                    <Tab label="Finance Statement" />
                    <Tab label="Balance Sheet" disabled={activeTab === 0} />
                    <Tab label="Income Statement" disabled={activeTab === 0 || activeTab === 1} />
                    <Tab label="Profit & Loss Statement" disabled={activeTab === 0 || activeTab === 1 || activeTab === 2}/>
                </Tabs>

                <Box sx={{ mt: 1, p: 2, borderRadius: "5px" }}>
                    {activeTab === 0 && <FinanceStatementCreate onSave={handleSaveSuccess} rowId={setRowId}/>}
                    {activeTab === 1 && <BalanceSheet onSave={handleSave} type="finance" rowId={rowId}/>}
                    {activeTab === 2 && <IncomeStatement type="finance" onSave={handleSaveIncrement} rowId={rowId} />}
                    {activeTab === 3 && <ProfitAndLossStatement  type="finance" rowId={rowId}/>}
                </Box>
            </CardContent>
        </Card>
    );
};

export default FinanceTabs;
